"use client";

import React from "react";
import { Droplets, Hand, Lock, ArrowRight, ArrowDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Purify",
  description: "A deep clarifying cleanse using botanical oils to dissolve impurities and prepare the scalp for treatment.",
  icon: Droplets
}, {
  title: "Stimulate",
  description: "Expert acupressure massage techniques to improve circulation and release deep-seated cranial tension.",
  icon: Hand
}, {
  title: "Nourish",
  description: "Application of nutrient-rich steam and herbal masks to restore hair health and scalp equilibrium.",
  icon: Lock
}];
export default function ThreeStepSetup() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}